import { GridColDef, GridRowsProp } from '@mui/x-data-grid';
import { useContext, useEffect, useState } from 'react';
import { AppContext } from '../../../app-context';
import IGridComponent from '../../../components/grid/i-grid.component';
import { getQualityStatus, saveQualityStatus } from '../order.services';
import { Grid, TextField } from '@mui/material';
import IButton from '../../../components/button/i-button.component';
import { isEmpty } from '../../common/util.services';

const QualityStatusComponent = (props: any) => {
  const appContext = useContext(AppContext);
  const rows: GridRowsProp = [];
  const [checkingStatus, setCheckingStatus] = useState(rows);
  const [qltyStatusData, setQltyStatusData] = useState<any>([]);
  const [qltyModel] = useState({orderId: null, costingId: null, linkId: null, challanId: null});
  const [approvedQty, setApprovedQty] = useState(-1);
  const [remarks, setRemarks] = useState(null);
  const [submitted, setSubmitted] = useState(false);
  const columns: GridColDef[] = [
    { field: 'parameter', headerName: 'Parameter', filterable: false, sortable: false, width: 160, editable: false },
    { field: 'expectedVal', headerName: 'Expected Value', filterable: false, sortable: false, width: 160, editable: false },
    { 
      field: 'status', headerName: 'Checked', filterable: false, sortable: false, width: 80, 
      editable: true, type: 'boolean',
      valueFormatter: (status: any) => status,
      valueSetter: (value, row) => { row.status = value; return value; }
    }
  ];
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    qltyModel.orderId = props.qltyData.orderId;
    qltyModel.costingId = props.qltyData.costingId;
    qltyModel.linkId = props.qltyData.linkId;
    qltyModel.challanId = props.qltyData.rowId;
    
    getQualityStatus(qltyModel, appContext,
      (response: any) => {
        setQltyStatusData(response.data);
        setCheckingStatus(response.data.checkingStatus);
        setRemarks(response.data.remarks);
        setApprovedQty(response.data.approvedQty);
        appContext.setShowLoader(false);
        setLoading(false);
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoading(false);
      });
  }, []);

  const processRowUpdate = (updatedRow: any, originalRow: any) => {
    const rows = [...checkingStatus];
    rows[updatedRow.id - 1] = updatedRow;
    setCheckingStatus(rows);
  }

  const onSubmit = () => {
    setSubmitted(true);
    if(isEmpty(approvedQty) || approvedQty < 0 || approvedQty > props.qltyData.quantity) {
      appContext.setDialogMessage('Specify valid approved quantity.');
      setSubmitted(false);
      return;
    }

    for(let i = 0; i < checkingStatus.length; ++i) {
      if(!checkingStatus[i].status) {
        appContext.setDialogMessage('Check all the parameters.');
        setSubmitted(false);
        return;
      }
    }

    qltyStatusData.checkingStatus = checkingStatus;
    qltyStatusData.approvedQty = approvedQty;
    qltyStatusData.inputCode = props.qltyData.inputCode;
    qltyStatusData.remarks = remarks;
    saveQualityStatus(qltyStatusData, appContext,
      (response: any) => {
        appContext.setShowLoader(false);
        setLoading(false);
        props.onSubmit();
      }, (error: any) => {
        console.log(error);
        appContext.setShowLoader(false);
        setLoading(false);
      });
  }

  const onCancel = () => {
    props.onCancel();
  }
  
  return <div>
    <Grid container spacing={1} maxWidth={450}>
      <Grid xs={6}>
        <TextField name='quantity' label='Received Quantity' required={true} disabled={true} value={props.qltyData.quantity} 
          margin='dense' inputProps={{ style: { height: "5px"}}}/>
      </Grid>
      <Grid xs={6}>
        <TextField name='approvedQty' label='Approved Quantity' required={true} disabled={false} value={approvedQty} type='number'
          margin='dense' inputProps={{ style: { height: "5px"}}} onChange={(e: any) => {setApprovedQty(Math.round(e.target.value))}}/>
      </Grid>
      <Grid xs={12}>
        <IGridComponent title='' rows={checkingStatus} columns={columns} getRowId={(row: any) => row.id} 
          apiRef={props.apiRef} maxHeight={'50vh'} hideFooterPagination={true} hideFooter={true} loading={loading} 
          processRowUpdate={processRowUpdate} disableRowSelectionOnClick={true}/>
      </Grid>
      <Grid xs={12}>
        <TextField name='remarks' label={'Checking Remarks'} multiline={true} fullWidth={true} InputLabelProps={{ shrink: true }}
          variant="outlined" rows={2} value={remarks} onChange={(e: any) => {setRemarks(e.target.value)}}/>
      </Grid>
      <div className='btn-panel'>
        <IButton name='submit' label='Submit' color="primary" onActionEvent={onSubmit} disabled={submitted}/>
        <IButton name='cancel' label='Cancel' color="secondary" onActionEvent={onCancel}/>
      </div>
    </Grid>
  </div>
}

export default QualityStatusComponent;